import { render, staticRenderFns } from "./InstitutionDetail.vue?vue&type=template&id=08921cc0&scoped=true&"
import script from "./InstitutionDetail.vue?vue&type=script&lang=js&"
export * from "./InstitutionDetail.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionDetail.vue?vue&type=style&index=0&id=08921cc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08921cc0",
  null
  
)

export default component.exports